export const environment = Object.freeze({
  production: false,
  base_url: 'https://epic-1-api.apprenticeshipindia.org',
  grievance_base_url: 'https://testimonial-dev.apprenticeshipindia.org',
  ga_token: null,
  // sentry_dsn: 'https://2d514f6ae3d94180a6c17cbc407d2268@sentry.io/1373716',
  btp_module: 'https://btp.apprenticeshipindia.org',
  recaptcha: {
    siteKey: '6Lc6ozcnAAAAAN8WAqq3q0Sm_KpVKZD6q3wfPZEC',
  },
  enableCaptcha: false
});
